module.exports = __webpack_public_path__ + "static/media/gtm.9b665c80.svg";